<template>
  <card-item card="item_feature" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Характеристики",
          component: () => import("./Features"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>